<template>
  <div class="page-notfound">
    <div class="container">
      <div class="hero is-medium is-primary" style="background-color:gray;padding:15px;">
        <div class="hero-body">
          <div class="container has-text-centered">
            <h1>
              Uh oh,
            </h1>
            <h2>
              404 - Page Not Found
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'notfound',
    metaInfo: {
      title: 'error 404 - not found'
    },
    components: {
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-notfound {
  font-family: $font-family;

  .hero.is-primary {
    color: $color-blue;
    font-size: 1.5em;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: bold;
  }
}

</style>



// WEBPACK FOOTER //
// NotFound.vue?2ff22afc